import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "sequenceField", "submissionSelector", "newSubmissionInput", "strainNameField"];

  connect() {
    // Initialize field states based on checkbox states
    this.checkboxesTargets.forEach(checkbox => {
      this.toggleFieldsForCheckbox(checkbox);
    });
  }

  toggleFields(event) {
    this.toggleFieldsForCheckbox(event.target);
  }

  toggleFieldsForCheckbox(checkbox) {
    const index = checkbox.dataset.index;
    const fields = this.element.querySelectorAll(`.sequence-field[data-index="${index}"]`);
    const isChecked = checkbox.checked;

    fields.forEach(field => {
      if (isChecked) {
        field.setAttribute('required', 'required');
        field.disabled = false;
        field.classList.remove('opacity-50', 'bg-gray-50');
      } else {
        field.removeAttribute('required');
        field.disabled = true;
        field.classList.add('opacity-50', 'bg-gray-50');
      }
    });
  }

  toggleNewSubmission(event) {
    const selector = event.target;
    const index = selector.dataset.index;
    const container = selector.closest('div');
    const newSubmissionInput = container.querySelector('.new-submission-input');
    const strainNameField = newSubmissionInput.querySelector('input[type="text"]');

    if (selector.value === '__new__') {
      newSubmissionInput.classList.remove('hidden');
      strainNameField.setAttribute('required', 'required');

      // Auto-fill with strain name if not already filled
      if (!strainNameField.value) {
        strainNameField.value = selector.dataset.strainName;
      }
    } else {
      newSubmissionInput.classList.add('hidden');
      strainNameField.removeAttribute('required');
    }
  }
}
